import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { fetchAdminTeams } from '../actions/teamsManagementActions';
import { FiSearch, FiPlus } from "react-icons/fi";
import defaultTeamLogo from "../images/defaultTeamLogo.png";
import { BASE_URL, API_URLS } from '../constants/config';
import { getTokensFromStore, checkIfTokenExpired } from '../utilities/tokens';
import { refreshTokens, logOut } from '../actions/usersActions';
import store from '../utilities/store';
import axios from 'axios';
import AddTeamModal from '../components/AddTeamModal';
import '../styles/teamsManagement.css';

export default function TeamsManagement(props) {
    const teams = useSelector(state => state.teamsManagement.teamsData);
    const loading = useSelector(state => state.teamsManagement.loading);
    const error = useSelector(state => state.teamsManagement.error);
    const dispatch = useDispatch();
    const history = useHistory();
    
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredTeams, setFilteredTeams] = useState([]);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const RESULTS_PER_PAGE = 50;

    useEffect(() => {
        _loadAsyncTeams();
    }, []);

    useEffect(() => {
        if (teams && teams.data && teams.data.length > 0) {
            filterTeams(searchQuery);
        }
    }, [teams, searchQuery]);

    const _loadAsyncTeams = () => {
        dispatch(fetchAdminTeams()).then(
            response => {
                console.log('Teams loaded:', response);
                if (response && response.data) {
                    console.log('Teams data:', response.data);
                    // Выведем первую команду для проверки структуры
                    if (response.data.length > 0) {
                        console.log('First team structure:', response.data[0]);
                        console.log('Available fields:', Object.keys(response.data[0]));
                    }
                }
            }
        );
    };

    const filterTeams = (query) => {
        if (!teams || !teams.data) {
            setFilteredTeams([]);
            return;
        }

        if (!query.trim()) {
            setFilteredTeams(teams.data);
            return;
        }

        const lowercaseQuery = query.toLowerCase();
        const filtered = teams.data.filter(team => {
            const teamName = (team.name || team.team_name || '').toLowerCase();
            return teamName.includes(lowercaseQuery);
        });

        setFilteredTeams(filtered);
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1); // Сбрасываем на первую страницу при поиске
    };

    const getTeamLogo = (team) => {
        // Проверяем все возможные поля для логотипа
        const logo = team.image || team.logo_url || team.logo || team.team_logo || '';
        console.log('Team logo check:', team.name || team.team_name, 'logo value:', logo);
        
        if (!logo || logo === '' || logo === '/images/others/defaultLogo.png') {
            return null;
        }
        
        // Если путь уже полный (начинается с http), возвращаем как есть
        if (logo.startsWith('http')) {
            return logo;
        }
        
        // Иначе добавляем BASE_URL
        return BASE_URL.url + logo;
    };

    const getTeamName = (team) => {
        return team.name || team.team_name || 'Без названия';
    };

    const getTeamId = (team) => {
        return team.team_id || team.id || 'N/A';
    };

    const renderTeamLogo = (team) => {
        const logoUrl = getTeamLogo(team);
        
        if (logoUrl) {
            return (
                <img 
                    src={logoUrl} 
                    alt={getTeamName(team)}
                    className="teamLogo"
                    onError={(e) => {
                        e.target.style.display = 'none';
                        const parent = e.target.parentElement;
                        if (parent) {
                            const placeholder = parent.querySelector('.teamLogoPlaceholder');
                            if (placeholder) {
                                placeholder.style.display = 'flex';
                            }
                        }
                    }}
                />
            );
        } else {
            return (
                <img 
                    src={defaultTeamLogo} 
                    alt={getTeamName(team)}
                    className="teamLogo"
                />
            );
        }
    };

    const handleAddTeam = async (teamData) => {
        try {
            console.log('Starting to add team with data:', teamData);
            
            // Проверяем и обновляем токены при необходимости
            const isTokenExpired = checkIfTokenExpired();
            if (isTokenExpired) {
                console.log('Token expired, refreshing...');
                await dispatch(refreshTokens());
            }
            
            const tokens = getTokensFromStore();
            console.log('Got tokens:', tokens ? 'yes' : 'no');
            
            // Получаем client_owner из Redux store
            const storeState = store.getState();
            const clientOwner = storeState?.user?.userData?.data?.client_id;
            console.log('Client Owner:', clientOwner);
            
            const url = BASE_URL.url + API_URLS.addTeam;
            console.log('Posting to URL:', url);

            // Формируем объект data согласно требованиям API
            const requestData = {
                data: {
                    name: teamData.name,
                    short_name: teamData.shortName || '',
                    client_owner: clientOwner
                }
            };
            
            // Если есть файл изображения
            if (teamData.logoFile) {
                // Конвертируем изображение в base64
                const reader = new FileReader();
                
                const base64Promise = new Promise((resolve, reject) => {
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(teamData.logoFile);
                });
                
                const base64Image = await base64Promise;
                console.log('Image converted to base64, length:', base64Image.length);
                
                // Убираем префикс "data:image/png;base64," или "data:image/jpeg;base64," и т.д.
                const base64Data = base64Image.split(',')[1];
                console.log('Pure base64 data length:', base64Data.length);
                
                // Отправляем JSON с чистым base64 изображением (без префикса)
                const requestData = {
                    data: {
                        name: teamData.name,
                        short_name: teamData.shortName || '',
                        client_owner: clientOwner,
                        image: base64Data
                    }
                };
                
                console.log('Sending JSON with base64 image:');
                console.log('- name:', teamData.name);
                console.log('- short_name:', teamData.shortName || '');
                console.log('- client_owner:', clientOwner);
                console.log('- image (base64):', base64Data.substring(0, 50) + '...');
                
                const response = await axios.post(url, requestData, {
                    headers: {
                        "Authorization": "Bearer " + tokens.access_token,
                        'Content-Type': 'application/json',
                    }
                });
                
                console.log('Team added successfully (with base64 image):', response.data);
            } else {
                // Без файла отправляем JSON
                console.log('Sending JSON without image:', requestData);
                
                const response = await axios.post(url, requestData, {
                    headers: {
                        "Authorization": "Bearer " + tokens.access_token,
                        'Content-Type': 'application/json',
                    }
                });
                
                console.log('Team added successfully (without image):', response.data);
            }
            
            // Закрываем модальное окно
            setIsAddModalOpen(false);
            
            // Перезагружаем список команд
            _loadAsyncTeams();
            
            // Показываем уведомление об успехе
            alert('Команда успешно добавлена!');
            
        } catch (error) {
            console.error('Error adding team:', error);
            console.error('Error response:', error.response);
            console.error('Error data:', error.response?.data);
            console.error('Error status:', error.response?.status);
            console.error('Error message:', error.message);
            
            // Если ошибка авторизации - выходим
            if (error.response?.status === 401) {
                console.log('Unauthorized, logging out...');
                dispatch(logOut());
                throw new Error('Сессия истекла. Пожалуйста, войдите заново.');
            }
            
            // Формируем понятное сообщение об ошибке
            let errorMessage = 'Ошибка при сохранении команды';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            throw new Error(errorMessage);
        }
    };

    return (
        <div className="layoutWrapper">
            <div className="matchCenterWrapper">
                <div className="matchCenterHeader">
                    <div className="simpleRow teamsManagementHeaderRow" style={{justifyContent:'space-between'}}>
                        <span className="teamsManagementName">Управление командами</span>
                        <button 
                            className="teamsManagementAddBtn"
                            onClick={() => setIsAddModalOpen(true)}
                        >
                            <FiPlus /> <span className="teamsManagementAddBtnText">Добавить команду</span>
                        </button>
                    </div>
                </div>

                <div className="teamsManagementTopBar">
                    <div className="searchSection">
                        <div className="searchBox">
                            <FiSearch className="searchIcon" />
                            <input
                                type="text"
                                className="searchInput"
                                placeholder="Поиск команды"
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />
                            {searchQuery && (
                                <button 
                                    className="clearSearch"
                                    onClick={() => setSearchQuery('')}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                        {filteredTeams.length > 0 && (
                            <div className="searchResults">
                                Найдено команд: <strong>{filteredTeams.length}</strong>
                                {filteredTeams.length > RESULTS_PER_PAGE && (
                                    <span> (показано {Math.min(RESULTS_PER_PAGE, filteredTeams.length)} из {filteredTeams.length})</span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                
                {loading ? (
                    <div className="loaderWrapper">
                        <Loader
                            type="Oval"
                            color="#4A5568"
                            height={80}
                            width={80}
                        />
                        <p style={{marginTop: '20px', color: '#718096'}}>Загрузка команд...</p>
                    </div>
                ) : error ? (
                    <div className="errorMessage">
                        <p>Ошибка загрузки команд: {error.message || 'Неизвестная ошибка'}</p>
                    </div>
                ) : filteredTeams.length > 0 ? (
                    <>
                        <div className="teamsGrid">
                            {filteredTeams.slice(
                                (currentPage - 1) * RESULTS_PER_PAGE,
                                currentPage * RESULTS_PER_PAGE
                            ).map((team, index) => (
                                <div 
                                    key={getTeamId(team) + '_' + index} 
                                    className="teamCard"
                                    onClick={() => history.push(`/teams_management/${getTeamId(team)}`)}
                                >
                                    <div className="teamCardHeader">
                                        <div className="teamLogoWrapper">
                                            {renderTeamLogo(team)}
                                        </div>
                                        <div className="teamInfo">
                                            <h3 className="teamName">{getTeamName(team)}</h3>
                                        </div>
                                    </div>
                                    <div className="teamCardBody">
                                        <div className="teamDetail">
                                            <span className="teamDetailLabel">ID:</span>
                                            <span className="teamDetailValue">{getTeamId(team)}</span>
                                        </div>
                                        {team.league_name && (
                                            <div className="teamDetail">
                                                <span className="teamDetailLabel">Лига:</span>
                                                <span className="teamDetailValue">{team.league_name}</span>
                                            </div>
                                        )}
                                        {team.players_count !== undefined && (
                                            <div className="teamDetail">
                                                <span className="teamDetailLabel">Игроков:</span>
                                                <span className="teamDetailValue">{team.players_count || 0}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        {filteredTeams.length > RESULTS_PER_PAGE && (
                            <div className="pagination">
                                <button 
                                    onClick={() => setCurrentPage(1)}
                                    disabled={currentPage === 1}
                                    className="paginationButton"
                                >
                                    ««
                                </button>
                                <button 
                                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                                    disabled={currentPage === 1}
                                    className="paginationButton"
                                >
                                    «
                                </button>
                                
                                {Array.from({ length: Math.ceil(filteredTeams.length / RESULTS_PER_PAGE) }, (_, i) => i + 1)
                                    .filter(page => {
                                        if (page === 1 || page === Math.ceil(filteredTeams.length / RESULTS_PER_PAGE)) return true;
                                        if (Math.abs(page - currentPage) <= 2) return true;
                                        return false;
                                    })
                                    .map((page, index, array) => {
                                        if (index > 0 && array[index - 1] !== page - 1) {
                                            return (
                                                <React.Fragment key={page}>
                                                    <span className="paginationEllipsis">...</span>
                                                    <button
                                                        onClick={() => setCurrentPage(page)}
                                                        className={`paginationButton ${currentPage === page ? 'active' : ''}`}
                                                    >
                                                        {page}
                                                    </button>
                                                </React.Fragment>
                                            );
                                        }
                                        return (
                                            <button
                                                key={page}
                                                onClick={() => setCurrentPage(page)}
                                                className={`paginationButton ${currentPage === page ? 'active' : ''}`}
                                            >
                                                {page}
                                            </button>
                                        );
                                    })}
                                
                                <button 
                                    onClick={() => setCurrentPage(prev => Math.min(Math.ceil(filteredTeams.length / RESULTS_PER_PAGE), prev + 1))}
                                    disabled={currentPage === Math.ceil(filteredTeams.length / RESULTS_PER_PAGE)}
                                    className="paginationButton"
                                >
                                    »
                                </button>
                                <button 
                                    onClick={() => setCurrentPage(Math.ceil(filteredTeams.length / RESULTS_PER_PAGE))}
                                    disabled={currentPage === Math.ceil(filteredTeams.length / RESULTS_PER_PAGE)}
                                    className="paginationButton"
                                >
                                    »»
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="emptyState">
                        {searchQuery ? (
                            <p>По запросу "{searchQuery}" ничего не найдено</p>
                        ) : (
                            <p>Команды не найдены</p>
                        )}
                    </div>
                )}

            <AddTeamModal 
                isOpen={isAddModalOpen}
                onClose={() => setIsAddModalOpen(false)}
                onSave={handleAddTeam}
            />
            </div>
        </div>
    );
}
